<template>
  <d-form @submit="doUpload">
    <div class="d-f-r d-fa-c d-fj-c">
      <img :src="form.image || value.thumb" alt="" style="height: 100px"/>
    </div>
    <d-form-file class="mb-3" v-model="form.designs" rules="required" label="Design (.EMB)"/>
    <d-form-file class="mb-3" v-model="form.image" rules="" label="Image (.PNG/.JPG)"/>
    <form-button
        type="info"
        inputType="submit"
        text="Upload Now"
        :loading="loading"
        :block="true"
        class="btn btn-lg btn-block"
    />
  </d-form>
</template>

<script>
import Modal from "@/components/Misc/Modal";
import LinkButton from "@/components/Misc/LinkButton";
import FilePicker from "@/components/Common/FilePicker";
import embApi from "@/store/api/emb";
import ErrorDisplay from "@/components/Common/ErrorDisplay";
import FileInput from "@/components/Common/FileInput";
import FormButton from "@/components/Form/FormButton";
import DForm from "@/components/Form/DForm";
import DFormFile from "@/components/Form/DFormFile";

export default {
  name: "DesignUploadForm",
  components: {
    DFormFile,
    DForm,
    FormButton,
    FileInput,
    ErrorDisplay,
    FilePicker,
    Modal,
    LinkButton,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      form: {
        designs: null,
        image: null
      },
      error: {},
      loading: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        this.validate(newVal)
      }
    }
  },
  methods: {
    validate(form) {
      let status = true;
      const error = {}
      if (!form.designs) {
        error.designs = ['can\'t be blank']
        status = false
      }
      this.error = error
      return status;
    },
    async doUpload() {
      if (!this.validate(this.form)) {
        return;
      }
      this.loading = true
      const api = embApi(this.$store.dispatch)
      const {data} = await api.uploadDesign(this.value.id, this.form)
      this.$emit('input', data)
    }
  }
}
</script>